
<app-cover-static-revision />
<app-student-revision-note />
<app-static-card-note />
<!-- <section>
       <h1 class=" mb-10 font-bold text-center xl:text-5xl lg:text-4xl md:text-3xl text-2xl ">Browse Revision Notes by subjects</h1>
       <app-browse-subjects />
</section> -->
<app-explore-tools />
